// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.quiz-completed {
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
  font-size: 2.5rem;
  font-weight: var(--roboto-regular);
  color: var(--secondary-color);
  margin: 30px;
}

.quiz-completed-icon {
  margin: 20px;
}

.final-score {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 2.8rem;
  font-weight: var(--roboto-regular);
  color: var(--primary-text);
  margin: 30px;
}

.final-score-icon {
  margin: 20px;
  color: var(--secondary-color);
}

.final-score-span {
  font-size: 5rem;
  font-weight: var(--roboto-bold);
  color: var(--primary-color);
  margin: 5px;
}

.quiz-completion-time {
  margin: 20px;
  color: var(--secondary-color);
  font-weight: var(--roboto-regular);
  font-size: 20px;
  font-size: 1.3rem;
}

.quiz-completion-time span {
  font-weight: var(--roboto-bold);
  color: var(--primary-color);
  font-style: italic;
}

.action-buttons-final-score-container {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 40px;
  padding: 5px;
  margin: 60px 60px 30px 60px;
}

.play-again-btn,
.back-to-setup-btn,
.back-to-categories-btn,
.share-btn {
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  background-color: var(--primary-color);
  text-align: center;
  text-decoration: none;
  border: 2px solid transparent;
  border-radius: 10px;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  font-weight: var(--roboto-bold);
  color: var(--bg-color);
  font-size: 20px;
  min-width: 250px;
  height: 50px;
}

.play-again-btn:hover,
.back-to-setup-btn:hover,
.back-to-categories-btn:hover,
.share-btn:hover {
  background-color: var(--secondary-color);
  color: var(--primary-text);
}

.statistics-container {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 40px;
  gap: 50px;
}

.quiz-breakdown-container {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin: 40px 30px;
}

.quiz-breakdown-container button {
  border: none;
  padding: 0;
  background-color: transparent;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 10px;
  text-align: center;
  text-decoration: none;
  cursor: pointer;
  font-family: "Roboto", sans-serif;
  font-weight: var(--roboto-bold);
  color: var(--primary-color);
  font-size: 20px;
  min-width: 200px;
  font-size: 1.5rem;
}

.quiz-breakdown-item {
  margin: 30px;
  font-size: 1.1rem;
}

.quiz-breakdown-correct-answer {
  margin: 10px;
  color: var(--secondary-text);
}

.quiz-breakdown-your-answer {
  margin: 10px;
}

p.quiz-breakdown-question {
  color: var(--secondary-color);
}

@media screen and (max-width: 1190px) {
  .quiz-completed {
    flex-direction: column;
    align-items: normal;
    gap: 10px;
    margin-top: 5px;
    margin-bottom: 20px;
  }

  .quiz-completed-icon {
    order: 1;
  }

  .quiz-completed-text {
    order: 2;
  }

  .action-buttons-final-score-container {
    flex-direction: column;
    align-items: center;
    gap: 30px;
    margin-top: 50px;
    margin-bottom: 30px;
  }

  .play-again-btn,
  .back-to-setup-btn,
  .back-to-categories-btn,
  .share-btn {
    width: 100%;
  }

  .statistics-container {
    flex-direction: column;
    align-items: center;
  }
}

@media screen and (max-width: 670px) {
  .quiz-completed-text {
    font-size: 2rem;
  }

  .final-score-text {
    font-size: 2rem;
    font-weight: var(--roboto-regular);
  }

  .final-score-span {
    font-size: 3rem;
  }

  .quiz-breakdown-item {
    font-size: 1rem;
  }
}

@media screen and (max-width: 500px) {
  .quiz-completed-text {
    font-size: 1.3rem;
  }

  .final-score-text {
    margin: 20px;
    font-size: 1.3rem;
  }

  .final-score-span {
    font-size: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/triviaCompletion/TriviaCompletion.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,uBAAuB;EACvB,sBAAsB;EACtB,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,6BAA6B;EAC7B,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,mBAAmB;EACnB,iBAAiB;EACjB,kCAAkC;EAClC,0BAA0B;EAC1B,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,6BAA6B;AAC/B;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,2BAA2B;EAC3B,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,6BAA6B;EAC7B,kCAAkC;EAClC,eAAe;EACf,iBAAiB;AACnB;;AAEA;EACE,+BAA+B;EAC/B,2BAA2B;EAC3B,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,YAAY;EACZ,2BAA2B;AAC7B;;AAEA;;;;EAIE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,sCAAsC;EACtC,kBAAkB;EAClB,qBAAqB;EACrB,6BAA6B;EAC7B,mBAAmB;EACnB,eAAe;EACf,iCAAiC;EACjC,+BAA+B;EAC/B,sBAAsB;EACtB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;;;;EAIE,wCAAwC;EACxC,0BAA0B;AAC5B;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,qBAAqB;EACrB,eAAe;EACf,iCAAiC;EACjC,+BAA+B;EAC/B,2BAA2B;EAC3B,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,YAAY;EACZ,4BAA4B;AAC9B;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,QAAQ;EACV;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;IACnB,SAAS;IACT,gBAAgB;IAChB,mBAAmB;EACrB;;EAEA;;;;IAIE,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,kCAAkC;EACpC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;AACF;;AAEA;EACE;IACE,iBAAiB;EACnB;;EAEA;IACE,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;AACF","sourcesContent":[".quiz-completed {\r\n  display: flex;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  font-size: 2.5rem;\r\n  font-weight: var(--roboto-regular);\r\n  color: var(--secondary-color);\r\n  margin: 30px;\r\n}\r\n\r\n.quiz-completed-icon {\r\n  margin: 20px;\r\n}\r\n\r\n.final-score {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  font-size: 2.8rem;\r\n  font-weight: var(--roboto-regular);\r\n  color: var(--primary-text);\r\n  margin: 30px;\r\n}\r\n\r\n.final-score-icon {\r\n  margin: 20px;\r\n  color: var(--secondary-color);\r\n}\r\n\r\n.final-score-span {\r\n  font-size: 5rem;\r\n  font-weight: var(--roboto-bold);\r\n  color: var(--primary-color);\r\n  margin: 5px;\r\n}\r\n\r\n.quiz-completion-time {\r\n  margin: 20px;\r\n  color: var(--secondary-color);\r\n  font-weight: var(--roboto-regular);\r\n  font-size: 20px;\r\n  font-size: 1.3rem;\r\n}\r\n\r\n.quiz-completion-time span {\r\n  font-weight: var(--roboto-bold);\r\n  color: var(--primary-color);\r\n  font-style: italic;\r\n}\r\n\r\n.action-buttons-final-score-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 40px;\r\n  padding: 5px;\r\n  margin: 60px 60px 30px 60px;\r\n}\r\n\r\n.play-again-btn,\r\n.back-to-setup-btn,\r\n.back-to-categories-btn,\r\n.share-btn {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 20px;\r\n  background-color: var(--primary-color);\r\n  text-align: center;\r\n  text-decoration: none;\r\n  border: 2px solid transparent;\r\n  border-radius: 10px;\r\n  cursor: pointer;\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: var(--roboto-bold);\r\n  color: var(--bg-color);\r\n  font-size: 20px;\r\n  min-width: 250px;\r\n  height: 50px;\r\n}\r\n\r\n.play-again-btn:hover,\r\n.back-to-setup-btn:hover,\r\n.back-to-categories-btn:hover,\r\n.share-btn:hover {\r\n  background-color: var(--secondary-color);\r\n  color: var(--primary-text);\r\n}\r\n\r\n.statistics-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  margin: 40px;\r\n  gap: 50px;\r\n}\r\n\r\n.quiz-breakdown-container {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  flex-direction: column;\r\n  margin: 40px 30px;\r\n}\r\n\r\n.quiz-breakdown-container button {\r\n  border: none;\r\n  padding: 0;\r\n  background-color: transparent;\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  gap: 10px;\r\n  text-align: center;\r\n  text-decoration: none;\r\n  cursor: pointer;\r\n  font-family: \"Roboto\", sans-serif;\r\n  font-weight: var(--roboto-bold);\r\n  color: var(--primary-color);\r\n  font-size: 20px;\r\n  min-width: 200px;\r\n  font-size: 1.5rem;\r\n}\r\n\r\n.quiz-breakdown-item {\r\n  margin: 30px;\r\n  font-size: 1.1rem;\r\n}\r\n\r\n.quiz-breakdown-correct-answer {\r\n  margin: 10px;\r\n  color: var(--secondary-text);\r\n}\r\n\r\n.quiz-breakdown-your-answer {\r\n  margin: 10px;\r\n}\r\n\r\np.quiz-breakdown-question {\r\n  color: var(--secondary-color);\r\n}\r\n\r\n@media screen and (max-width: 1190px) {\r\n  .quiz-completed {\r\n    flex-direction: column;\r\n    align-items: normal;\r\n    gap: 10px;\r\n    margin-top: 5px;\r\n    margin-bottom: 20px;\r\n  }\r\n\r\n  .quiz-completed-icon {\r\n    order: 1;\r\n  }\r\n\r\n  .quiz-completed-text {\r\n    order: 2;\r\n  }\r\n\r\n  .action-buttons-final-score-container {\r\n    flex-direction: column;\r\n    align-items: center;\r\n    gap: 30px;\r\n    margin-top: 50px;\r\n    margin-bottom: 30px;\r\n  }\r\n\r\n  .play-again-btn,\r\n  .back-to-setup-btn,\r\n  .back-to-categories-btn,\r\n  .share-btn {\r\n    width: 100%;\r\n  }\r\n\r\n  .statistics-container {\r\n    flex-direction: column;\r\n    align-items: center;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 670px) {\r\n  .quiz-completed-text {\r\n    font-size: 2rem;\r\n  }\r\n\r\n  .final-score-text {\r\n    font-size: 2rem;\r\n    font-weight: var(--roboto-regular);\r\n  }\r\n\r\n  .final-score-span {\r\n    font-size: 3rem;\r\n  }\r\n\r\n  .quiz-breakdown-item {\r\n    font-size: 1rem;\r\n  }\r\n}\r\n\r\n@media screen and (max-width: 500px) {\r\n  .quiz-completed-text {\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .final-score-text {\r\n    margin: 20px;\r\n    font-size: 1.3rem;\r\n  }\r\n\r\n  .final-score-span {\r\n    font-size: 1.5rem;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
